module.exports = __webpack_public_path__ + "img/introduce_elephant.e502ba34.png";